import { TimeUnit } from "../interface/time-format.model";

export const TIME_UNITS: TimeUnit[] = [
  {
    value: 'seconds',
    label: 'time_units.seconds',
    toSeconds: 1,
    toMinutes: 1/60,
    toHours: 1/3600,
    toMilliseconds: 1/1000
  },
  {
    value: 'minutes',
    label: 'time_units.minutes',
    toSeconds: 60,
    toMinutes: 1,
    toHours: 1/60,
    toMilliseconds: 1/60000
  },
  {
    value: 'hours',
    label: 'time_units.hours',
    toSeconds: 3600,
    toMinutes: 60,
    toHours: 1,
    toMilliseconds: 1/3600000
  },
  {
    value: 'days',
    label: 'time_units.days',
    toSeconds: 3600 * 24,
    toMinutes: 60 * 24,
    toHours: 24,
    toMilliseconds: 24 * 60 * 60 * 1000
  },
  {
    value: 'months',
    label: 'time_units.months',
    toSeconds: 3600 * 24 * 30,
    toMinutes: 60 * 24 * 30,
    toHours: 24 * 30,
    toMilliseconds: 24 * 30 * 60 * 60 * 1000
  },
  {
    value: 'months',
    label: 'time_units.months',
    toSeconds: 3600 * 24 * 30,
    toMinutes: 60 * 24 * 30,
    toHours: 24 * 30,
    toMilliseconds: 24 * 30 * 60 * 60 * 1000
  },
  {
    value: 'years',
    label: 'time_units.years',
    toSeconds: 3600 * 24 * 30 * 12,
    toMinutes: 60 * 24 * 30 * 12,
    toHours: 24 * 30 * 12,
    toMilliseconds: 24 * 30 * 12 * 60 * 60 * 1000
  },

];
